// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { PFixField } from './PFixField.js'
var PFixStringArrField = function (fieldId, buffer)
{
    this.Value = "";
    PFixField.call(this, fieldId, buffer)
}
PFixStringArrField.prototype = Object.create(PFixField.prototype);

PFixStringArrField.prototype.ReadValue = function (buffer)
{
    let length = buffer.ReadInt32();
    let list = new Array();

    for (let i = 0; i < length; i++)
        list.push(buffer.ReadString());

    this.Value = list;
};

PFixStringArrField.prototype.Write = function (buffer)
{
    buffer.WriteShort(this.FieldId);

    let length = this.Value.length;
    buffer.WriteInt32(length);

    for (let i = 0; i < length; i++)
        buffer.WriteString(this.Value[i]);
};

export { PFixStringArrField }